var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferralsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8572 17.417C17.7302 17.417 19.2492 15.899 19.2502 14.026V14.024V11.324C18.0132 11.324 17.0112 10.322 17.0102 9.085C17.0102 7.849 18.0122 6.846 19.2492 6.846H19.2502V4.146C19.2522 2.272 17.7352 0.752 15.8622 0.75H15.8562H4.1442C2.2702 0.75 0.751199 2.268 0.750199 4.142V4.143V6.933C1.9442 6.891 2.9452 7.825 2.9872 9.019C2.9882 9.041 2.9892 9.063 2.9892 9.085C2.9902 10.32 1.9912 11.322 0.756199 11.324H0.750199V14.024C0.749199 15.897 2.2682 17.417 4.1412 17.417H4.1422H15.8572Z",
    stroke: "#C1C6D3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3713 6.06303L10.9873 7.31003C11.0473 7.43203 11.1633 7.51703 11.2983 7.53703L12.6753 7.73803C13.0163 7.78803 13.1513 8.20603 12.9053 8.44503L11.9093 9.41503C11.8113 9.51003 11.7673 9.64703 11.7893 9.78203L12.0243 11.152C12.0823 11.491 11.7273 11.749 11.4233 11.589L10.1923 10.942C10.0713 10.878 9.92731 10.878 9.80631 10.942L8.57631 11.589C8.27131 11.749 7.91631 11.491 7.97431 11.152L8.20931 9.78203C8.23231 9.64703 8.18731 9.51003 8.08931 9.41503L7.09431 8.44503C6.84831 8.20603 6.98331 7.78803 7.32331 7.73803L8.70031 7.53703C8.83531 7.51703 8.95231 7.43203 9.01231 7.31003L9.62731 6.06303C9.77931 5.75503 10.2193 5.75503 10.3713 6.06303Z",
    stroke: "#C1C6D3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralsIcon);
export default __webpack_public_path__ + "static/media/referralsIcon.5b2461bc89f80f743173fb960f57a412.svg";
export { ForwardRef as ReactComponent };